import EmailApplicationContainer from "../../Componant/Email/EmailApplication";

const EmailApplication = () => {
  return (
    <div className="page-body">
      <EmailApplicationContainer />
    </div>
  );
};

export default EmailApplication;
